export default "/images/vendor/@coreui/icons/svg/flag/cif-ly.svg?b43eb99d1c57bd706e59a16fcf51b9d7";